var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"checkbox"},[_c('span',[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.changed}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }